import React from 'react'

import s from './styles.module.scss'

import { IconSvg } from '../../../components/atoms/icons'

const AddItem = ({
  label,
  onClick,
}: {
  label: string
  onClick: () => void
}) => (
  <div className={s.addItem} onClick={onClick}>
    <IconSvg.AddRound />
    <div className={s.label}>{label}</div>
  </div>
)

export default AddItem
